// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".autosuggest__results-item a[data-type^=empty]{white-space:inherit!important;font-size:.9em;font-style:italic;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
